import { AtlasAddressInput } from './AtlasAddressInput';

export { AtlasAddressInput };

// public entry point of the @wix/design-system/AtlasAddressInput subpath,
// consumed as a default import
// eslint-disable-next-line import/no-default-export
export default AtlasAddressInput;
